import React from "react";
import { useTheme } from "@emotion/react";
import {
  AppBar,
  Backdrop,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import * as Yup from "yup";
import RadioButtonComponent from "../../components/forms/RadioButtonComponent";
import Form from "../../components/forms/Form";
import InputComponent from "../../components/forms/InputComponent";
import SubmitButton from "../../components/forms/SubmitButton";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { brandCreate, getBrand } from "../../actions/brandActions";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  BRAND_CREATE_RESET,
  BRAND_UPDATE_RESET,
} from "../../constants/brandConstants";
import { updateBrand } from "../../actions/brandActions";
import { getcategory, updatecategory } from "../../actions/categoryActions";
import { CATEGORY_UPDATE_RESET } from "../../constants/categoryConstants";
import { getAttribute, updateAttribute } from "../../actions/attributeActions";
import { ATTRIBUTE_UPDATE_RESET } from "../../constants/attributeConstants";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters"),
  status: Yup.boolean().required("status is required"),
});

const EditAttribute = () => {
  const dispatch = useDispatch();

  const { palette } = useTheme();
  const navigate = useNavigate();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const attributeUpdate = useSelector((state) => state.attributeUpdate);
  const { loading, error, success } = attributeUpdate;

  const attributeGet = useSelector((state) => state.attributeGet);
  const {
    loading: loadingGet,
    error: errorGet,
    success: successGet,
    attribute,
  } = attributeGet;

  const params = useParams();

  useEffect(() => {
    if (!userInfo) {
      navigate("/", { replace: true });
    }

    if (params.id) {
      dispatch(getAttribute(params.id));
    }

    if (success) {
      navigate("/category");
      toast("Attribute updated successfully");
      dispatch({ type: ATTRIBUTE_UPDATE_RESET });
    }
  }, [userInfo, dispatch, navigate, success, params.id]);

  const handleSubmit = ({ name, status }) => {
    dispatch(updateAttribute({ _id: params.id, name, status }));
  };

  return (
    <Container>
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: 10,
          backgroundColor: palette.background.default,
        }}
      >
        {error && <Typography color="error">{error}</Typography>}

        <Typography variant="h5" component="h2">
          Edit Attribute
        </Typography>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "50%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {attribute && (
            <Form
              initialValues={{
                name: attribute.name,
                status: attribute.status,
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              <InputComponent label="name" />
              <RadioButtonComponent name={"status"} />
              <SubmitButton title={"Update attribute"} />
            </Form>
          )}
        </div>
      </Box>
    </Container>
  );
};

export default EditAttribute;
